import type { IGoogleAdsKeywordMutateResult } from "app/pages/digital-marketing/shared/google-ads/services/google-ads-proxy-client";
import { updateGoogleAdsImportedKeywords } from "app/services/keyword-groups/utils/googleAdsImportedKeywordGroups";

import type { GoogleAdsActionType } from "./google-ads-actions.types";

// "duplicate" means the keyword already exists in the ad group, so the state is already the one
// the action targets. A remove that found nothing to remove (`alreadyAbsent`) is the same case from
// the other side: Google Ads doesn't have the keyword, so the stale local "in Google Ads" state is
// corrected. Other "error" keywords are left untouched. "negative" doesn't change the add/remove
// choice (a negative keyword isn't a removable positive criterion).
export const applyGoogleAdsActionResults = (
    keywordGroupId: string,
    actionType: GoogleAdsActionType,
    results: IGoogleAdsKeywordMutateResult[],
): void => {
    if (actionType === "negative") {
        return;
    }

    const settledKeywords = results
        .filter(
            (result) =>
                result.status === "success" ||
                result.status === "duplicate" ||
                (actionType === "remove" && result.alreadyAbsent === true),
        )
        .map((result) => result.keyword);

    updateGoogleAdsImportedKeywords(keywordGroupId, {
        added: actionType === "add" ? settledKeywords : [],
        removed: actionType === "remove" ? settledKeywords : [],
    });
};
